import { Transition, Dialog } from "@headlessui/react";
import clsx from "clsx";
import { Fragment, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: string;
}>;

const RoundedModalContainerWithTransition: React.FC<Props> = ({
  children,
  className,
}) => {
  return (
    <Transition.Child
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0 scale-95"
      enterTo="opacity-100 scale-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100 scale-100"
      leaveTo="opacity-0 scale-95"
    >
      {/* Adds Transition for inner content */}
      <Dialog.Panel
        className={clsx(
          "relative overflow-hidden",
          "laptop:min-h-0   w-full transform rounded-t-md",
          "bg-gray-900  border-gray-800 laptop:rounded-md laptop:border",
          "laptop:px-12 laptop:py-14 border-t px-6 py-16",
          "laptop:max-w-xl shadow-xl transition-all",
          "dark",
          className,
        )}
      >
        {children}
      </Dialog.Panel>
    </Transition.Child>
  );
};

export default RoundedModalContainerWithTransition;
